import i18n from '@/i18n/i18n'
import BulutTahsilatService from '@/services/admin/BulutTahsilatService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = [
  'id',
  'payment_status_type_id',
  'paid_between',
  'order_id',
  'tarfin_pro_quotation_id',
  'matched_by',
  'nin',
  'sender_firm_bank_iban',
  'order_match_status',
  'payment_type_id',
  'refund_without_collection',
  'trashed'
]

export const state = {
  bankPayment: {},
  bankPayments: [],
  bankPaymentCounts: {},
  isAllowedToSwitchNextBankPayment: false
}

export const mutations = {
  SET_BANK_PAYMENTS(state, bankPayments) {
    state.bankPayments = bankPayments
  },
  SET_BANK_PAYMENT(state, bankPayment) {
    state.bankPayment = bankPayment
  },
  SET_BANK_PAYMENT_COUNTS(state, bankPaymentCounts) {
    state.bankPaymentCounts = bankPaymentCounts
  },
  REMOVE_BANK_PAYMENT_BY_ID(state, id) {
    state.bankPayments.data = state.bankPayments.data.filter(bankPayment => bankPayment.id !== id)
  },
  UPDATE_BANK_PAYMENT_BY_ID(state, data) {
    const bankPayments = [...state.bankPayments.data]
    const index = bankPayments.findIndex(bankPayment => bankPayment.id === data.id)
    bankPayments[index] = data
    state.bankPayments.data = bankPayments
  },
  SET_IS_ALLOWED_TO_SWITCH_NEXT_BANK_PAYMENT(state, isAllowedToSwitchNextBankPayment) {
    state.isAllowedToSwitchNextBankPayment = isAllowedToSwitchNextBankPayment
  }
}

export const actions = {
  getBankPayments({ commit, dispatch }, query) {
    if (query.hasOwnProperty('trashed') === false) {
      delete query.refund_without_collection
    }

    let newQuery = build_query(query, allowedFilters)

    return new Promise((resolve, reject) => {
      BulutTahsilatService.getBankPayments(newQuery)
        .then(response => {
          commit('SET_BANK_PAYMENTS', response)
          commit('SET_BANK_PAYMENT_COUNTS', response.counts)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.get_bank_payments_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBankPayment({ commit, dispatch }, query) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.getBankPayment(query.bank_payment_id)
        .then(response => {
          commit('SET_BANK_PAYMENT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.get_bank_payments_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getOrder({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.getOrder(query.bank_payment_id, query.order_id)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('constants.error_messages.incoming_payments_error_messages.get_order_by_promissory_id_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBankPaymentActivities({ dispatch }, bankPaymentId) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.getBankPaymentActivities(bankPaymentId)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  markAsManualCollection({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.markAsManualCollection(params.id, params.transaction_id)
        .then(response => {
          commit('UPDATE_BANK_PAYMENT_BY_ID', response.data)
          commit('REMOVE_BANK_PAYMENT_BY_ID', params.id)

          const notification = {
            type: 'success',
            message: 'Ödeme, seçilen tahsilat ile manuel olarak eşleştirildi.'
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.approve_bank_payment_error') +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteBankPayment({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.deleteBankPayment(id)
        .then(response => {
          commit('REMOVE_BANK_PAYMENT_BY_ID', id)

          const notification = {
            type: 'success',
            message: 'Gelen ödeme silinenlere taşındı.'
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.delete_bank_payment_error') +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  matchOrderForBankPayment({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.matchOrderForBankPayment(data)
        .then(response => {
          commit('REMOVE_BANK_PAYMENT_BY_ID', data.selectedData.id)

          const notification = {
            type: 'success',
            message: 'Ödeme başarıyla eşleştirildi.'
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.match_bank_payment_error') +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  unmatchOrderForBankPayment({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.unmatchOrderForBankPayment(data)
        .then(response => {
          commit('REMOVE_BANK_PAYMENT_BY_ID', data.selectedData.id)

          const notification = {
            type: 'success',
            message: 'Eşleştirme başarıyla kaldırıldı.'
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.unmatch_bank_payment_error') +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  approveBankPayment({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.approveBankPayment(
        data.selectedData.id,
        data.calculationDate || null,
        data.fullyPaidConfirmation || null,
        data.notifyFarmer || null
      )
        .then(response => {
          if (response.data?.waitingApproval === true) {
            const notification = {
              type: 'warning',
              message: t('store.shared.waiting_approval')
            }

            dispatch('notification/add', notification, {
              root: true
            })
          } else {
            commit('UPDATE_BANK_PAYMENT_BY_ID', response.data)
            commit('REMOVE_BANK_PAYMENT_BY_ID', data.selectedData.id)
          }

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.approve_bank_payment_error') +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteBankPaymentWithRefund({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.deleteBankPaymentWithRefund(id)
        .then(response => {
          commit('UPDATE_BANK_PAYMENT_BY_ID', response.data)
          commit('REMOVE_BANK_PAYMENT_BY_ID', id)

          const notification = {
            type: 'success',
            message: 'Gelen ödeme tahsilatsız iade ile silinenlere taşındı.'
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('constants.error_messages.incoming_payments_error_messages.delete_bank_payment_error') +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getTransactions({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.getTransactions(params.id, params.order_id)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  recalculateRemainingDebt({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.recalculateRemainingDebt(params.id, params.calculation_date)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  simulatePayment({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BulutTahsilatService.simulatePayment(params.id, params.calculation_date || null)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
